import { useSelector } from "@src/store";
import { getAnalyticsProducts } from "@src/store/slices/analyticsProducts";
import { selectedAudience } from "@src/store/slices/audiences";
import { getKeyMetricsRich } from "@src/store/slices/experienceMetrics/experienceMetrics";
import { selectedExperience } from "@src/store/slices/experiences";
import { selectedOffers } from "@src/store/slices/offers";
import { selectedInjections } from "@src/store/slices/onsiteInjections";
import { selectedPageTargeting } from "@src/store/slices/pageTargeting";
import { selectedRedirects } from "@src/store/slices/redirects";
import { selectedVariations } from "@src/store/slices/variations";

export const useWorkflowSelectors = () => {
  const variations = useSelector(selectedVariations);
  const experience = useSelector(selectedExperience);
  const redirects = useSelector(selectedRedirects);
  const audience = useSelector(selectedAudience);
  const experienceKeyMetrics = useSelector(getKeyMetricsRich);
  const pageTargeting = useSelector(selectedPageTargeting);
  const onsiteInjections = useSelector(selectedInjections);
  const analyticsProducts = useSelector(getAnalyticsProducts);
  const offers = useSelector(selectedOffers);

  return {
    variations,
    experience,
    redirects,
    audience,
    experienceKeyMetrics,
    pageTargeting,
    onsiteInjections,
    analyticsProducts,
    offers,
  };
};
